<template>
  <div class="top-bar">
    <div class="top-bar-left">
      <a :href="`tel:${phone}`" class="top-bar-link">
        <img
        src="/assets/images/icon/phone-icon.svg"
        alt="phone"
        class="top-bar-icon"
        width="16"
        height="16"
        loading="eager"
        decoding="async"
      >
        {{ phone }}
      </a>
      <span class="divider">|</span>
      <a :href="`mailto:${email}`" class="top-bar-link">
        <img
        src="/assets/images/icon/mail-icon.svg"
        alt="email"
        class="top-bar-icon"
        width="16"
        height="16"
        loading="eager"
        decoding="async"
      >
        {{ email }}
      </a>
    </div>
    <div class="top-bar-right">
      {{ address }}
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()
const phone = '0 800 30 20 20'
const email = 'shkolabiblii@gmail.com'
const address = computed(() => t('layout.header.topBar.address'))
</script>

<style scoped>
.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  font-family: var(--font-inter);
  font-weight: 500;
  font-size: 16px;
  color: #252840;
  max-width: 1677px;
  width: 86%;
  margin: 0 auto;
}

.top-bar-left {
  display: flex;
  align-items: center;
}

.top-bar-left a {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #252840;
  text-decoration: none;
  transition: color 0.2s;
}

.top-bar-left a:hover {
  color: #00CE9B;
}

.top-bar-icon {
  flex-shrink: 0;
  display: block;
}

.divider {
  color: #000;
  margin: 0 16px;
}

.top-bar-right {
  color: #252840;
}

@media (max-width: 991px) {
  .top-bar {
    width: 95%;
    padding: 12px 0;
  }
}

@media (max-width: 768px) {
  .top-bar {
    display: none;
  }
}
</style>

